import { generateActions } from '../utils';
import { API_CONST } from '../middlewares/api';
import { handleActions, createAction } from 'redux-actions';

const initial = {
  info: {},
}

const getInfoActions = generateActions('visits/info/GET_INFO')
const postActions = generateActions('visits/info/SET_INFO');
const feedback = generateActions('visits/info/feedback');

export const getFullInfo = createAction(
    API_CONST,
    (visitId) => ({
      url: `visits/${visitId}`,
      actions: getInfoActions,
    })
)

//отправка 3-х дат персоной на сервер
export const sendDates = createAction(
  API_CONST,
  (data = {}) => ({
    method: 'POST',
    params: { ...data},
    url: `visits/${data.visitId}`,
    actions: postActions
  })
)

//запрос пользователем или персоной связи с менеджером
export const sendFeedback = createAction(
  API_CONST,
  (data = {}) => ({
    method: 'POST',
    params: { ...data},
    url: `visits/${data.visitId}/sendfeedback`,
    actions: feedback
  })
)
export default handleActions({
  [getInfoActions[0]]: state => ({ ...initial }),
  [getInfoActions[1]]: (state, { payload = {} }) => ({...state, info: {...state.info, ...payload}}),
}, initial)


// WEBPACK FOOTER //
// ./src/store/reducers/visits.js